import {AddressGroupSummaryApiDto} from "../../api/model/rest";

/**
 * Group of addresses.
 */
export default class AddressGroupSummary {

	/**
	 * @param id id of the address.
	 * @param text text to display.
	 * @param description description.
	 */
	constructor(public readonly id: string,
		public readonly text: string,
		public readonly description: string) {}

	static fromJson(json: AddressGroupSummaryApiDto) {
		return new AddressGroupSummary(json.id, json.text, json.description)
	}
}